'use client';

import dynamic from 'next/dynamic';

/**
 * KeyMetricsList as an async chunk. /product/[slug] is one route shared by every
 * capability page, so a static import would ship GSAP + ScrollTrigger (~50KB gz)
 * to all of them; through next/dynamic only pages that render the band fetch it.
 * SSR stays on, so the server HTML still contains the final values.
 */
export const KeyMetricsListLazy = dynamic(() => import('./key-metrics-list').then(m => m.KeyMetricsList));
